import { ImgHTMLAttributes, useState } from 'react';

// Simple image that fades in when loaded...
export default function Image({
  className,
  onLoad,
  ...props
}: ImgHTMLAttributes<HTMLImageElement>) {
  // Use useState with a type annotation
  const [isLoaded, setIsLoaded] = useState<boolean>(false);

  return (
    <img
      {...props}
      className={`
        transition-opacity duration-200 
        ${isLoaded ? 'opacity-100' : 'opacity-0'}
        ${className}
      `}
      onLoad={(e) => {
        setIsLoaded(true);
        onLoad?.(e);
      }}
    />
  );
}
